<template>
  <div class="result-list-text-img-wrap">
    
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  components: {

  }
}
</script>
